module.exports = __webpack_public_path__ + "media/img/files/file-2-6f5a9f762d8553e8f820e6b271f12a06.jpg";